import { useIM, GroupStatusEvent } from '@wui/im'
import { defineStore } from 'pinia'
import { ref } from 'vue'

import { isPServedIsUser } from '@/shared/utils/uri'

import { ContactStatuses } from '../types'

export const useStoreContactStatus = defineStore('contacts-status', () => {
  const statuses = ref(new Map<string, ContactStatuses>())

  const { onConferenceUpdated } = useIM()
  onConferenceUpdated((event: GroupStatusEvent) => {
    const { pServed } = event
    if (!isPServedIsUser(pServed)) {
      return
    }

    statuses.value.set(pServed, {
      isOnline: event.isOnline,
      lastSeen: event.lastSeen,
      status: event.status,
      statusMessage: event.message,
    })
  })

  const getStatusByPServed = (pServed: string): ContactStatuses | undefined => {
    return statuses.value.get(pServed)
  }

  return {
    getStatusByPServed,
  }
})
